import _ from 'lodash'

import { d } from 'core/service/lib/decimal'

export const calculateCashDrop = (cashDropRate, sumAssured) => {
  if (cashDropRate < 0) return 0
  const multiplyResult = d(sumAssured).dividedBy(1000)
  return d(multiplyResult)
    .times(cashDropRate)
    .toNumber()
}

export const findCashDropRate = (productCode, cashDropRates) =>
  _.find(cashDropRates, (rate) => rate.productCode === productCode)

export const findNonGuaranteeCashDropRate = (productCode, cashDropRates) =>
  _.find(cashDropRates, (rate) => rate.productCode === `${productCode}_NON_G`)

export const queryCashDropRate = (gender, age, policyYear, filteredCashDropRates) => {
  const queryAge = age.unit !== 'year' ? 0 : age.value

  return _.get(filteredCashDropRates, ['cashDropRates', gender, queryAge.toString(), policyYear.toString()], 0)
}
